import React from 'react';
import * as R from 'ramda';
import { useNavigate } from 'react-router-dom';
import { arrayOf, shape, string } from 'prop-types';
import BlockRounded from '@mui/icons-material/BlockRounded';

// Components
import { Box, Button, Typography } from '@mui/material';

const EmptySubscriptionDataCard = ({ globalCustomers, message }) => {
  const navigate = useNavigate();

  return (
    <Box
      alignItems="center"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      textAlign="center"
    >
      <BlockRounded
        sx={{
          color: 'graphic.main',
          height: 40,
          mb: globalCustomers.length > 1 ? 2 : 2.5,
          mt: globalCustomers.length > 1 ? 2 : 0,
          mx: globalCustomers.length > 1 ? 2 : 0,
          width: 40,
        }}
      />
      <Typography sx={{ color: 'text.secondary' }} variant="body1">
        {message}
      </Typography>
      <Button
        onClick={() => navigate(-1)}
        sx={{
          // eslint-disable-next-line sort-keys-fix/sort-keys-fix
          display: { xs: 'none', md: R.isEmpty(globalCustomers) ? 'revert' : 'none' },
          marginTop: 4,
          width: 104,
        }}
      >
        Back
      </Button>
    </Box>
  );
};

EmptySubscriptionDataCard.propTypes = {
  globalCustomers: arrayOf(shape({})).isRequired,
  message: string.isRequired,
};

export default EmptySubscriptionDataCard;
